/**
 * All wedding-specific copy lives here. Edit this file, not the components.
 */

/**
 * The cities we're celebrating in, in the order they happen.
 * Rendered on the landing page and joined into one line in the footer.
 */
export const locations = ["Singapore", "Germany", "Vancouver"] as const;

export const site = {
  partnerOne: "Erik",
  partnerTwo: "Nicole",
  /** Shown as the big date on the landing page. */
  dateLabel: "September 12, 2026",
  locations,
  /** Single-line form, used where the list won't fit. */
  locationLabel: locations.join(" · "),
  heroTagline: "We're getting married, and we'd love you there.",
  story: "This is a story about how we met.",
  /** Where guests reply if something looks wrong. */
  contactEmail: "hello@example.com",
  /** Deadline copy on the RSVP form. */
  rsvpDeadlineLabel: "September 30, 2026",
} as const;

/**
 * Seeded into the `events` table on first boot. Slugs are stable identifiers —
 * changing a slug creates a new event rather than renaming the old one.
 */
export const defaultEvents = [
  {
    slug: "welcome-drinks",
    name: "Welcome Drinks",
    tagline: "Friday evening, casual",
    description:
      "Come say hello and grab a glass on the terrace. Drop in whenever you land — " +
      "no formal programme, just a soft landing after travel.",
    startsAt: "2026-09-11T18:00:00-07:00",
    endsAt: "2026-09-11T22:00:00-07:00",
    venueName: "The Barrel Room",
    address: "121 Vine Street, Sonoma, CA",
    mapUrl: "https://maps.google.com/?q=Sonoma+CA",
    dressCode: "Come as you are",
    sortOrder: 10,
  },
  {
    slug: "rehearsal-dinner",
    name: "Rehearsal Dinner",
    tagline: "Friday, family & wedding party",
    description:
      "A seated dinner for family and the wedding party the night before the ceremony.",
    startsAt: "2026-09-11T19:30:00-07:00",
    endsAt: "2026-09-11T23:00:00-07:00",
    venueName: "Olive Grove House",
    address: "8 Grove Lane, Sonoma, CA",
    mapUrl: "https://maps.google.com/?q=Sonoma+CA",
    dressCode: "Smart casual",
    sortOrder: 20,
  },
  {
    slug: "ceremony",
    name: "Ceremony & Reception",
    tagline: "Saturday — the main event",
    description:
      "Ceremony at four, followed by dinner, toasts, and dancing until late. " +
      "Shuttles run from the hotel starting at three.",
    startsAt: "2026-09-12T16:00:00-07:00",
    endsAt: "2026-09-13T00:00:00-07:00",
    venueName: "Vine Hill Estate",
    address: "455 Vine Hill Road, Sonoma, CA",
    mapUrl: "https://maps.google.com/?q=Sonoma+CA",
    dressCode: "Garden formal",
    sortOrder: 30,
  },
  {
    slug: "farewell-brunch",
    name: "Farewell Brunch",
    tagline: "Sunday morning, drop in",
    description:
      "Coffee, pastries, and long goodbyes before everyone scatters. Come by any time before noon.",
    startsAt: "2026-09-13T10:00:00-07:00",
    endsAt: "2026-09-13T12:30:00-07:00",
    venueName: "Hotel Sonoma Courtyard",
    address: "22 Plaza Street, Sonoma, CA",
    mapUrl: "https://maps.google.com/?q=Sonoma+CA",
    dressCode: "Whatever you woke up in",
    sortOrder: 40,
  },
] as const;

/**
 * Named bundles of events, used by the admin UI to assign a whole tier in one
 * click. Keys are arbitrary; values are event slugs.
 */
export const invitePresets: Record<string, readonly string[]> = {
  "Everyone (all weekend)": [
    "welcome-drinks",
    "rehearsal-dinner",
    "ceremony",
    "farewell-brunch",
  ],
  "Weekend guests": ["welcome-drinks", "ceremony", "farewell-brunch"],
  "Ceremony only": ["ceremony"],
  "Family & wedding party": [
    "welcome-drinks",
    "rehearsal-dinner",
    "ceremony",
    "farewell-brunch",
  ],
};
